var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuDropdownIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    draggable: "false",
    width: 16,
    height: 8,
    viewBox: "0 0 16 8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8345 0.900322C15.9448 0.797428 16 0.66881 16 0.527331C16 0.385852 15.9448 0.257234 15.8345 0.154341C15.6138 -0.0514466 15.2552 -0.0514466 15.0345 0.154341L8 6.71383L0.965517 0.154341C0.744827 -0.051446 0.386207 -0.051446 0.165517 0.154341C-0.0551727 0.360129 -0.0551727 0.694535 0.165517 0.900322L7.6 7.84566C7.82069 8.05145 8.17931 8.05145 8.4 7.84566L15.8345 0.900322Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDropdownIcon);
export default __webpack_public_path__ + "static/media/menu-dropdown-icon.41c94f1c.svg";
export { ForwardRef as ReactComponent };